import { ICrossSellB2CData, ICrossSellSMEData } from "../types/cross-sell-types.types";
import { API_PATHS } from "../constants/api-paths";
import { encryptedRequest, request } from "../core/api.client";

export interface ICrossSellSMEResponse {
  product: ICrossSellSMEData[];
}

export interface ICrossSellB2CResponse {
  productList: ICrossSellB2CData[];
}

export interface ICrossSellSMERequest {
  loanAmount: string;
  tenureInMonths: string;
  productType: string;
  dob?: string;
}

export interface ICrossSellB2CRequest {
  mobileNo: string;
  loanAmount: string;
  offerId?: string;
  dob?: string;
  processType?: string;
  processSegmentation?: string;
  icorsOfferType?: string;
}

export const getCrossSellSME = async (CrossSellProductRequest: ICrossSellSMERequest) => {
  const response = await request<ICrossSellSMEResponse, ICrossSellSMERequest>({
    method: "POST",
    url: API_PATHS.crossSellSme,
    data: CrossSellProductRequest,
  });

  return response;
};

export const getCrossSellB2C = async (
  CrossSellProductRequest: ICrossSellB2CRequest,
  cancelSignal?: AbortSignal
) => {
  const response = await encryptedRequest<ICrossSellB2CResponse, ICrossSellB2CRequest>({
    method: "POST",
    url: API_PATHS.crossSellB2C,
    data: {
      ...CrossSellProductRequest,
    },
    signal: cancelSignal,
  });
  return response;
};

export const getCrossSellB2CStatic = async () => {
  const response = await request<ICrossSellB2CResponse>({
    method: "GET",
    url: API_PATHS.crossSellB2CStatic,
  });
  return response;
};
